import { useMutation, useQueryClient } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import {
	saveTransactionVesting,
	removeVestingTermFromTransaction,
} from '@dealstack/frontend/shared/dataExchange/services/mip.service';
import { browserDateToMidnightUTC } from '@dealstack/frontend/shared/utils/utc';
import { TransactionVestingTermFormValues } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/HoldingTransactionsModal/TransactionVestingTermForm.types.ts';

export const useTransactionVestingTerm = (transactionId: string) => {
	const queryClient = useQueryClient();

	const refresh = () =>
		Promise.all(
			[
				API_PATHS.MIP_INVESTOR_HOLDINGS_ID_TRANSACTIONS_GET,
				API_PATHS.MIP_INVESTOR_VESTING_INVESTORID_SECURITYID_GET,
				API_PATHS.MIP_INVESTOR_VALUATIONS_ID_GET,
			].map((endpoint) => queryClient.invalidateQueries({ queryKey: [endpoint] }))
		);

	const save = useMutation({
		mutationFn: ({
			vestingTermId,
			vestingStartDate,
		}: {
			vestingTermId: string;
			vestingStartDate: TransactionVestingTermFormValues['vestingStartDate'];
		}) =>
			saveTransactionVesting({
				transactionId,
				vestingTermId,
				startDate: vestingStartDate ? browserDateToMidnightUTC(vestingStartDate) : null,
			}),
		onSettled: refresh,
	});

	const remove = useMutation({
		mutationFn: () => removeVestingTermFromTransaction({ transactionId }),
		onSettled: refresh,
	});

	return { save, remove };
};
